
export class RoleIdRequest {
    roleId: number;
    username?: string;

    constructor(roleId: number, username?: string) {
        this.roleId = roleId;
        this.username = username;
    }
}